import React from "react"
import Typography from '@material-ui/core/Typography';


function Error() {
  
  return (
    <div>  
    <Typography variant="h6">
      Page not found
    </Typography>
    </div>
  );
};

export default Error
